<template>
  <form class="p-index__top" id="select-search-form" name="search" action="/job" method="POST">
    <slot></slot>
    <div class="p-index__tab"  v-bind:class="{ 'is-anken_sp': isSearch }">
      <p class="p-index__tab__btn" v-bind:class="{ 'active': groupId == 1 }" v-for="(group, groupId) in groups" v-bind:key="groupId" v-show="tabHide(groupId)">{{group}}</p>
    </div>
    <div class="p-index__check">
      <div class="p-index__check__content"  v-bind:class="{ 'active': index == 0, 'is-flex': index==0, 'is-p36': index == 3, 'is-flex-tab50': index==1 || index==2, 'is-flex-tab32': index==3 }" v-for="(listItems, index) in items" v-bind:key="index">
        <label v-for="(item, j) in listItems" v-bind:key="j">
          <input type="checkbox" name="tags[]" :value="item.value" v-model="values">
          <span>{{ item.label }}</span>
        </label>
      </div>

    </div>
    <div class="p-index__tag">
      <p class="p-index__tag__title center"><span>条件にチェックを入れてタグで案件検索</span></p>
      <div class="p-index__tag__content">
        <span v-for="(value, index) in values" v-bind:key="index">{{itemList[value].label}}<button type="button" @click="removeSelect(value)"></button></span>
      </div>
      <div class="p-index__tag__submit">
        <input type="hidden" v-model="qValue" name="q">
        <input type="submit" class="p-index__tag__submit" value="上記条件でタグ検索">
      </div>
    </div>
  </form>
</template>

<script>
import {TagGroup} from '@/plugins/global-constant'
export default {
  props: {
    items : {
      type: Array | Object,
      default: [],
      required: true,
    },
    groups: {
      type: Array | Object,
      default: [],
      required: true,
    },
    selected : {
      type: Array | null,
      default: null,
      required: false,
    },
    isSearch : {
      type: Boolean,
      default: false,
      required: false,
    },
    query : {
      type : String,
      default : '',
      required: false,
    }
  },
  components: {
  },
  data() {
    return {
      values: this.selected,
      itemList: [],
      qValue : this.query
    }
  },
  methods: {
    submit() {
      $('form[name="search"]').submit();
    },

    setList() {
      _.each(this.items, (list, key) => {
        _.each(list, (item, key) => {
          this.itemList[item.value] = item;
        });
      });
    },

    removeSelect(val) {
      const index = this.values.indexOf(val);
      if (index > -1) {
        this.values.splice(index, 1);
      }

    },

    tabHide (group) {

      return group == TagGroup.UnitPrice ? false : true
    }
  },
  created() {
    this.setList();
  },
  mounted() {
  },
  computed: {
  },
  watch: {
    values(val) {
    },
  },
}
</script>
